module.exports = __webpack_public_path__ + "static/media/live-streaming-bg.7d396fa5.png";